import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/finally';
import { Injectable } from '@angular/core';
import { api } from '../api';
import { RouteName } from '../../shared/constants';
import { Storage } from '../constants';
import { TranslationLoaderService } from '../translation/translation-loader.service';
import { BrandingService } from '../branding/branding.service';

@Injectable()
export class SettingsService {
  handleError: any;
  settings: any;
  isLicensed = true;
  isGoogleAPIConfigured = false;
  constructor(
    private http: HttpClient,
    private translationLoader: TranslationLoaderService,
    private brandingService: BrandingService) {

  }
  // TODO /*caching should be implemented and all setting definition keys should be read from cache. */
  GetSettings() {
    return this.http.get<any[]>(api.settings.REC_SETTINGS);
  }
  GetLoginSettings() {
    return this.http.get<any[]>(api.settings.GET_LOGIN_SETTINGS);
  }
  GetAppSettings() {
    return this.http.get(api.settings.APP_SETTINGS)
      .map(data => this.BootstrapAppSettings(data))
      .switchMap(() => Observable.of(true));
  }

  getCaptchaKey() {
    return this.http.get(api.settings.GET_CAPTCHA_KEY);
  }

  loadSettings() {
    return new Promise((resolve, reject) => {
      this.GetAppSettings()
        .subscribe((firstResponse) => {
          this.translationLoader.getTranslations(['TRANSLATIONS_CAREER_CORE'])
            .subscribe((secondResponse) => {
              resolve(true);
            });
          this.brandingService.setTheme();
        });
    });
  }

  private BootstrapAppSettings(data: any) {
    if (data['error'] === 'AccessDenied') {
      this.isLicensed = false;
    }
    if (data['authurl']) {
      window.localStorage.setItem(Storage.AUTH_URL, data['authurl']);
    }
    if (data['loginurl']) {
      window.localStorage.setItem(Storage.LOGIN_URL, data['loginurl']);
    }
    if (data['resetPasswordurl']) {
      window.localStorage.setItem(Storage.RESET_PASSWORD_URL, data['resetPasswordurl']);
    }
    if (data['careerHomeUrl']) {
      window.localStorage.setItem(Storage.HOME_REDIRECT_URL, data['careerHomeUrl']);
    }
    if (data['careerLogoUrl']) {
      window.localStorage.setItem(Storage.LOGO_REDIRECT_URL, data['careerLogoUrl']);
    }
    if (data['realm']) {
      window.localStorage.setItem(Storage.REALM, data['realm']);
    }
    if (data['datastore']) {
      window.localStorage.setItem(Storage.DATASTORE, data['datastore']);
    }
    if (data['translationsHash']) {
      window.localStorage.setItem(Storage.TRANSLATIONS_HASH, data['translationsHash']);
    }
    if (data['elixHRUIUrl']) {
      const url = this.formatUrl(data['elixHRUIUrl']);
      window.localStorage.setItem(Storage.ELIXHRUI_URL, url);
    }
    if (data['viewMatchPercent']) {
      window.localStorage.setItem(Storage.VIEW_MATCH_PERCENT, data['viewMatchPercent']);
    }
    if (data['enableJobAlert']) {
      window.localStorage.setItem(Storage.ENABLE_JOB_ALERT, data['enableJobAlert']);
    }
  }

  private formatUrl(url): string {
    if (url) {
      // To ensure that elixHRUIUrl ends with /
      if (!url.endsWith('/')) {
        url = url + '/';
      }
    }
    return url;
  }

}



// WEBPACK FOOTER //
// ../UI/src/app/shared/settings/settings.service.ts